// config/AppVersion.js
export const appVersion = 'v1.0.08'; // Versão do aplicativo